import Hero from "./Hero";
import Container from "./ui/Container";
import SectionHeader from "./ui/SectionHeader";
import { PrimaryButton } from "./ui/Buttons";

// Import partner logos
import licHflLogo from "../assets/lic-hfl-logo.png";
import federalBakLogo from "../assets/federal-bank-logo.png";
import idbiLogo from "../assets/idbi-bank-logo.png";
import indianBankLogo from "../assets/indian-bank-logo.jpg";
import bankOfBarodaLogo from "../assets/bank-of-baroda-bank-logo.png";
import punjabBankLogo from "../assets/punjab-bank-logo.png";
import pnbLogo from "../assets/png-finance-logo.png";
import southIndianLogo from "../assets/south-indian-bank-logo.png";
import gicLogo from "../assets/gic-loho.png";
import dbcLogo from "../assets/dbc-logo.png";
import karurBankLogo from "../assets/kvb-logo.png";
import karnatakaBankLogo from "../assets/karnataka-bank-logo.png";
import kotakBankLogo from "../assets/kiotak-bank-logo.png";
import repcoHomeFinanceLogo from "../assets/repco-logo.png";
import aadharFinanceLogo from "../assets/aadhar-logo.png";
import primalLogo from "../assets/piramal-finance-logo.png";
import fedLogo from "../assets/fedbank-logo.jpg";
import mahindraBankLogo from "../assets/mahindra-finance-logo.webp";
import shriramLogo from "../assets/shriram-logo.webp"
import SundaramLogo from "../assets/sundharam-home-logo.png";
import specialDoc from "../assets/special-productions.pdf";
import { useState } from "react";
import team1 from "../assets/team1.jpeg";
import team2 from "../assets/team2.jpeg";
import team4 from "../assets/team5.jpeg";
import team5 from "../assets/team6.jpeg";
import team6 from "../assets/team12.jpeg";
import team7 from "../assets/team13.jpeg";

export default function Thawa() {
    const loans = [
        { type: "Home Loan", desc: "Affordable EMIs to buy your dream house." },
        { type: "Loan Against Property (LAP)", desc: "Leverage your property to meet financial needs." },
        { type: "Educational Loan", desc: "Finance your education with low-interest loans." },
        { type: "Car Loan", desc: "Get your dream car with easy repayment options." },
        { type: "Commercial Vehicle Loan", desc: "Expand your business with commercial vehicles." },
        { type: "Business Loan", desc: "Support to grow your business efficiently." },
        { type: "Personal Loan", desc: "Flexible loans for personal needs." },
    ];

    const partners = [
        { name: "LIC HFL", logo: licHflLogo },
        { name: "Federal Bank", logo: federalBakLogo },
        { name: "IDBI Bank", logo: idbiLogo },
        { name: "Indian Bank", logo: indianBankLogo },
        { name: "Bank of Baroda", logo: bankOfBarodaLogo },
        { name: "Punjab National Bank", logo: punjabBankLogo },
        { name: "PNB Housing", logo: pnbLogo },
        { name: "South Indian Bank", logo: southIndianLogo },
        { name: "GIC Housing Finance LTD", logo: gicLogo },
        { name: "DCB Bank", logo: dbcLogo },
        { name: "Karur Vyaya Bank", logo: karurBankLogo },
        { name: "Karnataka Bank Ltd", logo: karnatakaBankLogo },
        { name: "Kotak Mahindra Bank", logo: kotakBankLogo },
        { name: "Repco Home Finance", logo: repcoHomeFinanceLogo },
        { name: "Aadhar Housing Fianance Ltd", logo: aadharFinanceLogo },
        { name: "Primal Finance", logo: primalLogo },
        { name: "FED Bank", logo: fedLogo },
        { name: "Mahindra Home Finance", logo: mahindraBankLogo },
        { name: "SHRIRAM Housing Finance", logo: shriramLogo },
        { name: "Sundaram Home", logo: SundaramLogo },
    ];

    const addresses = [
        { title: "Pollachi Home Loan Servicing Point", address: "86/13, Thernilayam, Udumalai Road, Pollachi - 642001" },
        { title: "Corporate Office", address: "Old No.21, New No.65, 1st Floor, Velachery Main Road, Little Mount, Saidapet, Chennai - 600015." },
        { title: "Madurai Zonal Office", address: "Shop No. C, Ground Floor, AR Plaza, No.16 & 17, North Veli Street, Madurai - 625001." },
        { title: "Tirchy Zonal Office", address: "Flat No. EF/2, (EFB) 1st Floor, Warners Gems Apartment, Warners Road, Cantonment, Tirchy - 620001." },
        { title: "Coimbatore Zonal Office", address: "Sri Lakshmi Narayana Building, 1st Floor, No,24, Tatabas 2nd street, Sivanandacolony, Coimbatore - 641012" },
    ];

    // Add your team images here
    const teamImages = [
        team1,
        team2,
        team4,
        team5,
        team6,
        team7
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev === 0 ? teamImages.length - 1 : prev - 1));
    };

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev === teamImages.length - 1 ? 0 : prev + 1));
    };

    return (
        <>
            <Hero />

            {/* Intro Section */}
            <section className="py-16 bg-gray-50">
                <Container>
                    <div className="md:flex md:items-center md:justify-between">
                        <div className="md:w-2/3">
                            <SectionHeader
                                title="Thawa Financial Services Pvt Ltd."
                                subtitle="Comprehensive Loan Solutions"
                            />
                            <p className="mt-4 text-gray-700 max-w-3xl">
                                Thawa is a private financial service company offering a variety of loans
                                to cater to your personal, educational, and business needs. Our goal is
                                to provide fast, reliable, and flexible financial solutions.
                            </p>
                        </div>

                        {/* Button on the right */}
                        <div className="mt-6 md:mt-0 md:w-1/3 flex justify-end">
                            <a
                                href="/special-productions.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
                            >
                                Download Applications
                            </a>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Loan Cards */}
            <section className="py-8 bg-gray-100">
                <Container>
                    <h2 className="text-2xl font-bold mb-6">Our Loan Products</h2>
                    <div className="grid md:grid-cols-3 gap-6">
                        {loans.map((loan, i) => (
                            <div key={i} className="p-6 bg-white shadow rounded-lg hover:shadow-lg hover:scale-105 transition-transform duration-300">
                                <h3 className="text-xl font-bold text-blue-600">{loan.type}</h3>
                                <p className="mt-2 text-gray-600">{loan.desc}</p>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>

            {/* Partners Section */}
            <section className="py-16 bg-white">
                <Container>
                    <h2 className="text-2xl font-bold mb-6">Our Partners</h2>
                    <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
                        {partners.map((p, i) => (
                            <div key={i} className="p-4 bg-gray-50 shadow rounded-lg flex items-center justify-center hover:shadow-lg transition-shadow duration-300">
                                <img src={p.logo} alt={p.name} className="h-16 object-contain" />
                            </div>
                        ))}
                    </div>
                </Container>
            </section>

            {/* Our Special Productions Section */}
            <section className="py-16 bg-white">
                <Container>
                    <SectionHeader
                        title="Our Special Productions"
                        subtitle="Special Production Documents for Download"
                    />
                    <p className="mt-4 text-gray-700 max-w-3xl">
                        You can download the special production documents for your reference.
                    </p>
                    <div className="mt-6 flex justify-start">
                        <a
                            href={specialDoc}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors"
                        >
                            Download Document
                        </a>
                    </div>
                </Container>
            </section>

            <section className="py-16 bg-gray-50">
                <div className="container mx-auto text-center">
                    <h2 className="text-2xl font-bold mb-8">Team Presentation</h2>

                    <div className="relative max-w-md mx-auto">
                        {/* Current Image */}
                        <img
                            src={teamImages[currentIndex]}
                            alt={`Team member ${currentIndex + 1}`}
                            className="w-full h-96 object-cover rounded-lg shadow-lg"
                        />

                        {/* Navigation Buttons */}
                        <button
                            onClick={prevSlide}
                            className="absolute left-0 top-1/2 -translate-y-1/2 bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700"
                        >
                            ◀
                        </button>
                        <button
                            onClick={nextSlide}
                            className="absolute right-0 top-1/2 -translate-y-1/2 bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700"
                        >
                            ▶
                        </button>
                    </div>
                </div>
            </section>

            {/* Addresses Section */}
            <section className="py-16 bg-gray-50">
                <Container>
                    <h2 className="text-2xl font-bold mb-6">Our Addresses</h2>
                    <div className="grid md:grid-cols-2 gap-6">
                        {addresses.map((a, i) => (
                            <div key={i} className="p-6 bg-white shadow rounded-lg">
                                <h3 className="font-semibold text-blue-600">{a.title}</h3>
                                <p className="mt-2 text-gray-700">{a.address}</p>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>

            {/* CTA Section */}
            <section className="py-16 bg-blue-50">
                <Container className="text-center">
                    <h2 className="text-2xl font-bold mb-4">Start Your Loan Application</h2>
                    <p className="text-gray-700 mb-6">
                        Contact us today to explore the best loan options for your needs.
                    </p>
                    <PrimaryButton onClick={() => window.location.href = "/contact"}>
                        Contact Us
                    </PrimaryButton>
                </Container>
            </section>
        </>
    );
}
